import { render, staticRenderFns } from "./SubPrimaryText.vue?vue&type=template&id=2afd61a7&scoped=true&"
var script = {}
import style0 from "./SubPrimaryText.vue?vue&type=style&index=0&id=2afd61a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd61a7",
  null
  
)

export default component.exports